import { queryClient, apiRequest } from "../lib/queryClient";

const contactKey = "contact";

export function useContactUs(options = {}) {
  const {
    filters = {},
    sort = { field: "created_at", direction: "desc" },
    pagination = { page: 1, limit: 10 },
  } = options;

  const fetchContactUs = async () => {
    const queryParams = new URLSearchParams();
    queryParams.append("page", pagination.page);
    queryParams.append("limit", pagination.limit);
    queryParams.append("sortField", sort.field);
    queryParams.append("sortDirection", sort.direction);
    for (const [key, value] of Object.entries(filters)) {
      if (value !== undefined && value !== null && value !== "") {
        queryParams.append(key, value);
      }
    }
    const response = await apiRequest(
      `/admin/contact-us?${queryParams.toString()}`,
      {
        method: "GET",
      }
    );
    return response;
  };

  const fetcContactUsById = async (pageId) => {
    const response = await apiRequest(`/admin/contact-us/${pageId}`, {
      method: "GET",
    });
    return response;
  };

  const createContactUs = async (pageData) => {
    const response = await apiRequest("/admin/contact-us", {
      method: "POST",
      body: JSON.stringify(pageData),
    });
    queryClient.invalidateQueries({ queryKey: [contactKey] });
    return response;
  };

  const updatContactUs = async (id, pageData) => {
    const response = await apiRequest(`/admin/contact-us/${id}`, {
      method: "PUT",
      body: JSON.stringify(pageData),
    });
    queryClient.invalidateQueries({ queryKey: [contactKey] });
    return response;
  };

  const deletContactUs = async (pageId) => {
    await apiRequest(`/admin/contact-us/${pageId}`, {
      method: "DELETE",
    });
    queryClient.invalidateQueries({ queryKey: [contactKey] });
    return pageId;
  };

  const toggleIsResolved = async (id, data) => {
    const response = await apiRequest(`/admin/contact-us/${id}`, {
      method: "PATCH",
      body: JSON.stringify(data),
    });
    queryClient.invalidateQueries({ queryKey: [contactKey] });
    return response;
  };

  return {
    fetchContactUs,
    fetcContactUsById,
    createContactUs,
    updatContactUs,
    deletContactUs,
    toggleIsResolved
  };
}
